// extracted by mini-css-extract-plugin
export default {"content_block":"IssueOverview_content_block__+i198","stats_block":"IssueOverview_stats_block__fNgSC","divider":"IssueOverview_divider__6ux6i"};